<template>
  <div class="choice-question">
    <div class="answer__table">
      <div v-if="question.is_correct !== null" class="answer__table-correct-answer">
        {{ $tr('responses.tabs.test.correctAnswer') }}
      </div>

      <div class="answer__table-selected">{{ $tr('responses.tabs.test.candidateAnswer') }}</div>
    </div>

    <div v-for="answer in question.answers" :key="answer.id" class="answer">
      <div v-if="question.is_correct !== null" class="answer__correct-answer" :class="[getStatusClass(answer)]">
        <i v-if="answer.is_valid" class="icon-check"></i>
      </div>

      <div class="answer__selected" :class="[getStatusClass(answer)]">
        <i v-if="answer.is_chosen" class="icon-check"></i>
      </div>

      <div class="answer__body">{{ answer.body }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResponseChoiceQuestion',

  props: {
    question: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    isMultiChoice() {
      return this.question.answers.reduce((sum, answer) => (answer.is_valid ? ++sum : sum), 0) > 1;
    },

    haveValid() {
      return this.question.answers.some(answer => answer.is_valid);
    }
  },

  methods: {
    getStatusClass(answer) {
      if (this.question.is_correct === null) return '';
      if (answer.is_chosen === answer.is_valid && this.question.is_correct !== null) return 'green';
      if (this.isMultiChoice || answer.is_chosen) return 'red';

      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.choice-question {
  .answer {
    display: flex;
    padding: 10px 15px;
    border-bottom: 1px solid $grey-light;

    &__table {
      display: flex;
      @include mixin-text-tag;
    }

    &__table-correct-answer,
    &__table-selected {
      width: 95px;
      padding: 0 5px;
    }

    &__correct-answer,
    &__selected {
      width: 95px;
      padding: 0 5px;
    }

    .status {
      font-weight: 500;
      padding-bottom: 4px;
    }

    &__body {
      flex: 1;
      @include mixin-text-main;
    }

    .green {
      color: $green !important;
      background-color: transparent !important;
      border-color: transparent !important;
    }

    .red {
      color: $red !important;
      background-color: transparent !important;
      border-color: transparent !important;
    }
  }
}
</style>
